import { Component, OnInit, OnDestroy, inject, NgZone } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MessageService } from 'primeng/api';
import { UserService } from '@app/auth/services/user.service';
import { Router, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Pagination } from '@app/shared/components/api/models/pagination.model';
import { CampanhaService } from '@app/shared/components/api/services/campanha.service';
import { forkJoin, of, catchError, map } from 'rxjs';
import { SkeletonLoaderComponent } from '@app/shared/components/skeleton-loader/skeleton-loader.component';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { CardCampanhaGrandComponent } from '@app/shared/components/card-campanha-grand/card-campanha-grand.component';
import { UtilizadoresService } from '@app/shared/components/api/services/utilizadores.service';

import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { CampanhaDestaqueService } from '@app/shared/components/api/services/campanha-destaque.service';
import { AuthService } from '@app/auth/services/auth.service';
import { GestaoPaginaService } from '@app/shared/components/api/services/gestao-pagina.service';
import { GestaoPaginaEnum } from '@app/shared/components/api/models/gestaoPagina.model';
import { AnexoFicheiroService } from '@app/shared/components/api/services/anexo-ficheiro.service';
import { DashboardService } from '@app/shared/components/api/services/dashboard.service';
import { ProvinciaService } from '@app/shared/components/api/services/provincia.service';

@Component({
  selector: 'app-banner',
  imports: [CommonModule, RouterLink],
  providers: [
    DynamicDialogRef,
    UserService,
    CampanhaService,
    UtilizadoresService,
    CampanhaDestaqueService,
    AnexoFicheiroService,
    DashboardService,
    ProvinciaService,
  ],
  standalone: true,
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
})
export class BannerComponent implements OnInit, OnDestroy {
  private readonly authService = inject(AuthService);
  private readonly userService = inject(UserService);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly messageService = inject(MessageService);
  private readonly campanhaService = inject(CampanhaService);
  private readonly campanhaDestaqueService = inject(CampanhaDestaqueService);
  private readonly utilizadoresService = inject(UtilizadoresService);
  private readonly dashboardService = inject(DashboardService);
  private readonly provinciaService = inject(ProvinciaService);
  private readonly gestaoPaginaService = inject(GestaoPaginaService);
  private readonly anexoFicheiroService = inject(AnexoFicheiroService);
  private readonly route = inject(Router);
  IsAuthenticad: boolean = false;
  utilizador: any;
  IsprofileComplet: boolean = false;

  campanhasDestaque: any[] = [];
  currentIndex: number = 0;
  private intervalId: any = null;
  animating: boolean = false;
  isPaused: boolean = false;
  loadingCampanhas: boolean = false;

  banner: any;
  stats: any = {
    totalCampanhas: 0,
    totalApoios: 0,
    totalUtilizador: 0,
    pagamentosConfirmados: 0,
    totalProvincias: 18,
    taxaSucesso: 73,
  };
  imgPreview?: string;
  loading: boolean = false;
  subTitulo: string = '';
  header: string = '';

  // Carrossel de Banner da Página Inicial (Slide 0: Hero Atual, Slide 1: Imagem do Banner Principal)
  bannerSlideIndex: number = 0;
  totalBannerSlides: number = 2;
  bannerPrincipalImg: any = null;
  loadingBannerPrincipal: boolean = false;
  private bannerCarouselIntervalId: any = null;

  irParaCampanha(campanha: any) {
    if (!campanha?.id) {
      this.route.navigate(['/campanhas']);
      return;
    }
    this.route.navigate(['/detalhe-campanha/', campanha.id]);
  }

  private fieldLabels: Record<string, string> = {
    id: 'Identificador',
    userName: 'Nome de utilizador',
    email: 'Email',
    dataCriacao: 'Data de criação',
    dataCriacaoFormatada: 'Data de criação',
    ativo: 'Estado da conta',
    dataNascimento: 'Data de nascimento',
    iban: 'IBAN',
    telefone: 'Telefone',
    tipoDocumentoENUM: 'Tipo de documento',
    tipoDocumento: 'Tipo de documento',
    numeroDocumento: 'Número do documento',
  };

  ngOnInit(): void {
    this.authService.isAuthenticatedChange().subscribe((isAuth) => {
      this.IsAuthenticad = isAuth;
    });
    this.getMideaByEnum();
    this.carregarBannerPrincipal();
    this.iniciarBannerAutoplay();
    this.loadContents();
    this.carregarCampanhasDestaque();
    this.getUser();
    this.checkProfileUSer();
    this.getStatsBanner();
  }

  loadContents() {
    forkJoin({
      // Valores
      subTitulo: this.gestaoPaginaService.getTituloPrincipal(),
      header: this.gestaoPaginaService.getHeader(),
    }).subscribe((response) => {
      ((this.header = response.header ?? ''),
        (this.subTitulo = response.subTitulo ?? ''));
    });
  }

  isCampanhaValida(c: any): boolean {
    if (!c || !c.id) return false;

    const estado = Number(c.estadoCampanhaENUM);
    const estadoDesc = (c.estadoCampanha || '').toLowerCase();

    // 1. Estados estritamente não permitidos:
    // 1 = Rascunho, 2 = Pendente, 5 = Suspensa, 7 = Recusado
    if ([1, 2, 5, 7].includes(estado)) return false;
    if (
      estadoDesc.includes('rascunho') ||
      estadoDesc.includes('pendente') ||
      estadoDesc.includes('suspens') ||
      estadoDesc.includes('recusad') ||
      estadoDesc.includes('cancel')
    ) {
      return false;
    }

    // 2. Campanhas de sucesso (meta atingida / concluída)
    const meta = Number(c.metaArrecadar) || 0;
    const arrecadado = Number(c.valorArrecado) || 0;
    const pct =
      Number(c.percentualConcluido) ||
      (meta > 0 ? (arrecadado / meta) * 100 : 0);
    const atingiuMeta = meta > 0 && (arrecadado >= meta || pct >= 100);

    const isSucessoOuConcluida =
      estado === 6 || // Sucesso
      estado === 9 || // Concluída
      estadoDesc.includes('sucesso') ||
      estadoDesc.includes('concluíd') ||
      estadoDesc.includes('concluid') ||
      atingiuMeta;

    if (isSucessoOuConcluida) {
      return true;
    }

    // 3. Campanhas em andamento (ativas):
    // Estado 4 (Em curso) ou texto correspondente, e NÃO expiradas sem sucesso
    const isEmAndamento =
      estado === 4 ||
      estadoDesc.includes('curso') ||
      estadoDesc.includes('andamento') ||
      estadoDesc.includes('activ') ||
      estadoDesc.includes('ativ');

    const isExpirada =
      Boolean(c.expirado) ||
      (c.diasRestantes !== undefined &&
        c.diasRestantes !== null &&
        Number(c.diasRestantes) <= 0);

    if (isEmAndamento && !isExpirada) {
      return true;
    }

    // Demais casos (ex: encerradas sem bater a meta)
    return false;
  }

  carregarCampanhasDestaque() {
    this.loadingCampanhas = true;
    const userId = this.userService.getUserId() || '';

    const params: any = {
      PageSize: 20,
      PageNumber: 1,
      pageSize: 20,
      pageNumber: 1,
      OrderBy: 'id desc',
    };
    if (userId) {
      params.UtilizadorCurtiuID = userId;
    }

    this.campanhaDestaqueService.list(params).subscribe({
      next: (res: any) => {
        const rawDestaques = (res?.data || []).map((d: any) =>
          d?.campanha ? { ...d.campanha, destaqueId: d.id } : d,
        );

        // Agrupa eliminando duplicados por ID
        const mapa = new Map<number, any>();
        rawDestaques.forEach((camp: any) => {
          if (camp?.id && !mapa.has(Number(camp.id))) {
            mapa.set(Number(camp.id), camp);
          }
        });

        // Exibe todas as campanhas retornadas pelo serviço de destaque,
        // apenas excluindo rascunhos (1) ou recusadas (7) caso existam
        const todasDestaques = Array.from(mapa.values());
        const campanhasParaExibir = todasDestaques.filter(
          (c: any) =>
            c &&
            c.id &&
            Number(c.estadoCampanhaENUM) !== 1 &&
            Number(c.estadoCampanhaENUM) !== 7,
        );

        if (campanhasParaExibir.length === 0) {
          this.campanhasDestaque = [];
          this.loadingCampanhas = false;
          return;
        }

        // Inicializa fotoUrl inicial para render imediato
        campanhasParaExibir.forEach((campanha: any) => {
          if (!campanha.fotoUrl && !campanha.imgPreview) {
            campanha.fotoUrl = '/images/campanha-1.png';
          }
        });

        this.campanhasDestaque = campanhasParaExibir;
        this.currentIndex = 0;
        this.loadingCampanhas = false;
        this.startAutoplay();

        // Carrega fotos reais e detalhes de cada campanha através do serviço detalhado
        campanhasParaExibir.forEach((campanha: any) => {
          const campanhaID = campanha.id;
          if (!campanhaID) return;

          this.campanhaService.show(campanhaID.toString()).subscribe({
            next: (detalheRes: any) => {
              const campanhaDetalhada = detalheRes?.data;
              if (!campanhaDetalhada) return;

              // Enriquecer propriedades da campanha se ausentes
              if (campanhaDetalhada.categoria && !campanha.categoria) {
                campanha.categoria = campanhaDetalhada.categoria;
              }
              if (campanhaDetalhada.provincia && !campanha.provincia) {
                campanha.provincia = campanhaDetalhada.provincia;
              }
              if (
                campanhaDetalhada.utilizadorNome &&
                !campanha.utilizadorNome
              ) {
                campanha.utilizadorNome = campanhaDetalhada.utilizadorNome;
              }
              if (
                campanhaDetalhada.expirado !== undefined &&
                campanha.expirado === undefined
              ) {
                campanha.expirado = campanhaDetalhada.expirado;
              }
              if (
                campanhaDetalhada.diasRestantes !== undefined &&
                campanha.diasRestantes === undefined
              ) {
                campanha.diasRestantes = campanhaDetalhada.diasRestantes;
              }

              const fotoAnexo = campanhaDetalhada.anexoCampanha?.find(
                (a: any) =>
                  (a?.tipoAnexoCampanha?.tipo || '')
                    .toString()
                    .toLowerCase() === 'imagem',
              );

              if (fotoAnexo?.anexo?.url) {
                campanha.fotoUrl = fotoAnexo.anexo.url;
                campanha.imgPreview = fotoAnexo.anexo.url;
                return;
              }

              if (fotoAnexo?.anexo?.id) {
                this.anexoFicheiroService
                  .getAnexo(fotoAnexo.anexo.id)
                  .subscribe({
                    next: (fotoRes: any) => {
                      const blob =
                        fotoRes instanceof Blob
                          ? fotoRes
                          : new Blob([fotoRes], { type: 'image/png' });
                      const imgUrl = this.sanitizer.bypassSecurityTrustUrl(
                        URL.createObjectURL(blob),
                      );
                      campanha.fotoUrl = imgUrl;
                      campanha.imgPreview = imgUrl;
                    },
                    error: (err) => {
                      console.error('Erro ao buscar anexo de imagem:', err);
                    },
                  });
              }
            },
            error: (err) => {
              console.error('Erro ao buscar detalhes da campanha:', err);
            },
          });
        });
      },
      error: (err) => {
        console.error('Erro ao carregar campanhas em destaque', err);
        this.loadingCampanhas = false;
      },
    });
  }

  get campanhaAtual(): any {
    if (!this.campanhasDestaque || this.campanhasDestaque.length === 0) {
      return null;
    }
    return (
      this.campanhasDestaque[this.currentIndex] || this.campanhasDestaque[0]
    );
  }

  formatarMoedaFloat(val?: number): string {
    const v = Number(val) || 0;
    if (v >= 1_000_000_000) {
      const b = v / 1_000_000_000;
      return (
        b.toLocaleString('pt-AO', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 1,
        }) + ' B Kz'
      );
    }
    if (v >= 1_000_000) {
      const m = v / 1_000_000;
      return (
        m.toLocaleString('pt-AO', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 1,
        }) + ' M Kz'
      );
    }
    if (v >= 1_000) {
      const k = v / 1_000;
      return (
        k.toLocaleString('pt-AO', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 1,
        }) + ' mil Kz'
      );
    }
    return v.toLocaleString('pt-AO', { maximumFractionDigits: 0 }) + ' Kz';
  }

  formatarMoedaCard(val?: number): string {
    const v = Number(val) || 0;
    if (v >= 1_000_000) {
      const m = v / 1_000_000;
      return (
        m.toLocaleString('pt-AO', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 1,
        }) + ' M Kz'
      );
    }
    if (v >= 1_000) {
      const k = v / 1_000;
      return (
        k.toLocaleString('pt-AO', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 1,
        }) + ' mil Kz'
      );
    }
    return v.toLocaleString('pt-AO', { maximumFractionDigits: 0 }) + ' Kz';
  }

  getPercent(campanha: any): number {
    if (!campanha?.metaArrecadar || campanha.metaArrecadar <= 0) return 0;
    const arrecadado = Number(campanha.valorArrecado) || 0;
    const meta = Number(campanha.metaArrecadar);
    return Math.min(100, Math.round((arrecadado / meta) * 100));
  }

  isCampanhaSucesso(campanha: any): boolean {
    if (!campanha) return false;
    const estado = Number(campanha.estadoCampanhaENUM);
    const estadoDesc = (campanha.estadoCampanha || '').toLowerCase();
    const meta = Number(campanha.metaArrecadar) || 0;
    const arrecadado = Number(campanha.valorArrecado) || 0;
    return (
      estado === 6 ||
      estado === 9 ||
      estadoDesc.includes('sucesso') ||
      estadoDesc.includes('concluid') ||
      estadoDesc.includes('concluíd') ||
      (meta > 0 && arrecadado >= meta)
    );
  }

  getDiasRestantesTexto(campanha: any): string {
    if (!campanha) return 'Em andamento';
    if (this.isCampanhaSucesso(campanha)) {
      return 'Meta atingida';
    }
    if (
      campanha.diasRestantes !== undefined &&
      campanha.diasRestantes !== null
    ) {
      const dias = Number(campanha.diasRestantes);
      if (dias > 0) return `${dias} dias restantes`;
      if (dias === 0) return 'Termina hoje';
    }
    return 'Em andamento';
  }

  limparTexto(texto?: string): string {
    if (!texto) return '';
    return texto.replace(/\\n/g, ' ').replace(/\n/g, ' ').trim();
  }

  callRouteViewCampanhas() {
    this.route.navigate(['/campanhas']);
  }

  getUser(): void {
    const userId = this.userService.getUserId();
    if (userId) {
      this.utilizadoresService.show(userId).subscribe({
        next: (res) => {
          this.utilizador = res.data;
        },
        error: (err) => {
          console.error(err);
        },
      });
    } else {
      console.error('User ID is null');
      return;
    }
  }

  checkProfileUSer() {
    this.utilizadoresService
      .checkPerfilUser(this.userService.getUserId() || '')
      .subscribe({
        next: (res: any) => {
          if (res?.retorno.codigo === 200) {
            this.IsprofileComplet = res?.data;
          } else {
            this.IsprofileComplet = false;
          }
        },
      });
  }

  callRouteCreateCampanha() {
    if (!this.authService.isLoggedIn()) {
      this.openLogin('/criar-campanha');
      return;
    }

    this.checkProfileUSer();
    if (this.IsprofileComplet) {
      this.route.navigate(['/criar-campanha/']);
    } else if (this.IsAuthenticad) {
      this.perfilIncomplete(this.utilizador);
      this.route.navigate(['/perfil']);
      return;
    } else {
      this.route.navigate(['/criar-campanha/']);
    }
  }

  ngOnDestroy(): void {
    this.stopAutoplay();
    this.pararBannerAutoplay();
  }

  next(event?: Event): void {
    if (event) event.stopPropagation();
    if (this.campanhasDestaque.length <= 1) return;
    this.triggerAnimation();
    this.currentIndex = (this.currentIndex + 1) % this.campanhasDestaque.length;
  }

  prev(event?: Event): void {
    if (event) event.stopPropagation();
    if (this.campanhasDestaque.length <= 1) return;
    this.triggerAnimation();
    this.currentIndex =
      (this.currentIndex - 1 + this.campanhasDestaque.length) %
      this.campanhasDestaque.length;
  }

  goTo(index: number, event?: Event): void {
    if (event) event.stopPropagation();
    if (
      index === this.currentIndex ||
      index < 0 ||
      index >= this.campanhasDestaque.length
    ) {
      return;
    }
    this.triggerAnimation();
    this.currentIndex = index;
    this.restartAutoplay();
  }

  triggerAnimation(): void {
    this.animating = true;
    setTimeout(() => {
      this.animating = false;
    }, 450);
  }

  startAutoplay(): void {
    this.stopAutoplay();
    if (this.campanhasDestaque.length > 1) {
      this.intervalId = window.setInterval(() => {
        if (!this.isPaused) {
          this.next();
        }
      }, 6000);
    }
  }

  stopAutoplay(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  restartAutoplay(): void {
    this.stopAutoplay();
    this.startAutoplay();
  }

  pauseAutoplay(): void {
    this.isPaused = true;
  }

  resumeAutoplay(): void {
    this.isPaused = false;
  }

  openLogin(returnUrl?: string): void {
    if (returnUrl) {
      this.route.navigate(['/auth/login'], { queryParams: { returnUrl } });
    } else {
      this.route.navigate(['/auth/login']);
    }
  }

  perfilIncomplete(user: any): boolean {
    const requiredFields = [
      'id',
      'userName',
      'email',
      'dataCriacao',
      'ativo',
      'dataNascimento',
      'iban',
      'telefone',
      'tipoDocumentoENUM',
      'numeroDocumento',
    ];

    const missingFields = requiredFields.filter((field) => {
      const value = user[field];

      return (
        value === null ||
        value === undefined ||
        (typeof value === 'string' && value.trim() === '') ||
        (Array.isArray(value) && value.length === 0)
      );
    });

    if (missingFields.length) {
      const friendlyNames = missingFields.map(
        (field) => this.fieldLabels[field] || field,
      );

      this.messageService.add({
        severity: 'warn',
        summary: 'Perfil incompleto',
        detail: `Por favor complete: ${friendlyNames.join(', ')}`,
        life: 5000,
      });

      return true;
    }

    return false;
  }

  getMideaByEnum() {
    this.gestaoPaginaService
      .listPublic({ GestaoPaginaENUM: GestaoPaginaEnum.BannerPrincipal })
      .subscribe({
        next: (result) => {
          this.banner = result.data[0];
          this.getPhoto(this.banner?.anexoID);
        },
        error: (error) => {
          console.error(error);
        },
      });
  }

  getPhoto(id: any) {
    if (!id) return;
    this.anexoFicheiroService.getAnexo(id).subscribe({
      next: (fotoRes: any) => {
        const blob = fotoRes instanceof Blob ? fotoRes : new Blob([fotoRes]);
        const url = this.sanitizer.bypassSecurityTrustUrl(
          URL.createObjectURL(blob),
        ) as any;
        this.imgPreview = url;
        if (!this.bannerPrincipalImg) {
          this.bannerPrincipalImg = url;
        }
      },
      error: (err) => console.error(err),
    });
  }

  carregarBannerPrincipal(): void {
    this.loadingBannerPrincipal = true;
    this.gestaoPaginaService.getBannerPrincipal().subscribe({
      next: (res: any) => {
        if (
          res &&
          typeof res === 'string' &&
          (res.startsWith('http') ||
            res.startsWith('/') ||
            res.startsWith('data:'))
        ) {
          this.bannerPrincipalImg = res;
          this.loadingBannerPrincipal = false;
        } else if (res && !isNaN(Number(res))) {
          this.carregarFotoBannerPrincipal(Number(res));
        } else if (res) {
          this.bannerPrincipalImg = res;
          this.loadingBannerPrincipal = false;
        } else {
          this.buscarBannerPrincipalPorList();
        }
      },
      error: () => {
        this.buscarBannerPrincipalPorList();
      },
    });
  }

  buscarBannerPrincipalPorList(): void {
    this.gestaoPaginaService
      .listPublic({ GestaoPaginaENUM: GestaoPaginaEnum.BannerPrincipal })
      .subscribe({
        next: (result) => {
          const item = result?.data?.[0];
          if (item?.anexoID) {
            this.carregarFotoBannerPrincipal(item.anexoID);
          } else if (item?.valor) {
            this.bannerPrincipalImg = item.valor;
            this.loadingBannerPrincipal = false;
          }
        },
        error: (err) => {
          console.error(err);
          this.loadingBannerPrincipal = false;
        },
      });
  }

  carregarFotoBannerPrincipal(id: any): void {
    if (!id) return;
    this.anexoFicheiroService.getAnexo(id).subscribe({
      next: (fotoRes: any) => {
        const blob = fotoRes instanceof Blob ? fotoRes : new Blob([fotoRes]);
        this.bannerPrincipalImg = this.sanitizer.bypassSecurityTrustUrl(
          URL.createObjectURL(blob),
        ) as any;
        this.loadingBannerPrincipal = false;
      },
      error: (err) => {
        console.error(err);
        this.loadingBannerPrincipal = false;
      },
    });
  }

  nextBannerSlide(event?: Event): void {
    if (event) event.stopPropagation();
    this.bannerSlideIndex =
      (this.bannerSlideIndex + 1) % this.totalBannerSlides;
  }

  prevBannerSlide(event?: Event): void {
    if (event) event.stopPropagation();
    this.bannerSlideIndex =
      (this.bannerSlideIndex - 1 + this.totalBannerSlides) %
      this.totalBannerSlides;
  }

  goToBannerSlide(index: number, event?: Event): void {
    if (event) event.stopPropagation();
    this.bannerSlideIndex = index;
  }

  iniciarBannerAutoplay(): void {
    this.pararBannerAutoplay();
    this.bannerCarouselIntervalId = setInterval(() => {
      if (!this.isPaused) {
        this.nextBannerSlide();
      }
    }, 8000);
  }

  pararBannerAutoplay(): void {
    if (this.bannerCarouselIntervalId) {
      clearInterval(this.bannerCarouselIntervalId);
      this.bannerCarouselIntervalId = null;
    }
  }

  getStatsBanner() {
    forkJoin({
      statsPublicas: this.dashboardService
        .getEstatisticasPublicas()
        .pipe(catchError(() => of(null))),
      provincias: this.provinciaService
        .list({ pageSize: 100 })
        .pipe(catchError(() => of({ data: [] }))),
    }).subscribe({
      next: (res: any) => {
        const stats = res.statsPublicas || {};

        // Províncias Abrangidas (vindo do back via requisição)
        const provData = res.provincias;
        const totalProvincias =
          provData?.totalRecords ??
          provData?.total ??
          (Array.isArray(provData?.data) && provData.data.length > 0
            ? provData.data.length
            : 18);

        this.stats = {
          ...this.stats,
          totalCampanhas: stats.totalCampanhas ?? 0,
          totalCampanhasAoAr: stats.totalCampanhas ?? 0,
          totalCampanhasAtivas: stats.totalCampanhasAtivas ?? 0,
          totalApoios: stats.pagamentosConfirmados ?? 0,
          pagamentosConfirmados: stats.pagamentosConfirmados ?? 0,
          totalUtilizador: stats.totalUtilizadoresAtivos ?? 0,
          totalProvincias,
          taxaSucesso: stats.taxaSucesso ?? 0,
        };
      },
      error: (err) => {
        console.error('Erro ao carregar estatísticas do banner:', err);
      },
    });
  }
}
